<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dPkset/tc-custom/9781504047241.jpg?1734280283603" alt="This image is the cover for the book Quicksilver Pool"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quicksilver Pool
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times</i>–bestselling author: After the Civil War, a young Confederate bride finds herself living in the shadow of her husband’s first love.</b><br/>  <br/> Having lost her fiancé in battle, Lora Blair knew it was the heartache of war, not true love, that drew her to Union soldier Wade Tyler, a grieving widower who still mourned his late wife, Virginia. Married quickly in the ravished little Southern border town where Lora was born, they headed back North to Wade’s Staten Island mansion, where he lives with his motherless son and bitterly unwelcoming family.<br/>  <br/> It’s not just Lora’s Southern roots among wealthy Yankees that are met with severe disapproval. Lora knows that she’ll forever be in the shadow of Wade’s adored, devotedly maternal, and peerlessly beautiful first wife. Though her most dangerous opposition is yet to come, Lora must face the secrets hidden in the Tylers’ past—including those Virginia took with her to an early grave.<br/>  <br/> The recipient of the Agatha Award for Lifetime Achievement, Phyllis A. Whitney is “a superb and gifted storyteller” (Mary Higgins Clark).<br/>  <br/><i>This ebook features an illustrated biography of Phyllis A. Whitney including rare images from the author’s estate.</i><br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Phyllis A. Whitney
      </h2>
      
      <p class="authorDescription body article">Born in Yokohama, Japan, on September 9, 1903, Phyllis A. Whitney was a prolific author of award-winning adult and children&rsquo;s fiction. Her sixty-year writing career and the publication of seventy-six books, which together sold over fifty million copies worldwide, established her as one of the most successful mystery and romantic suspense writers of the twentieth century and earned her the title &ldquo;The Queen of the American Gothics.&rdquo;<BR /><BR /> Whitney resided in several places, including New Jersey. She traveled to every location mentioned in her books in order to better depict the settings of her stories. She earned the Mystery Writers of America Grand Master award in 1988, the Agatha in 1990, and the lifetime achievement award from the Society of Midland Authors in 1995. Whitney was working on her autobiography at the time of her passing at the age of 104.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e0bf22c